// React
import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
// Locales
import translate from 'locales/i18n';
// Material components
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import LinearProgress from '@mui/material/LinearProgress';
//Actions
import SignAction from 'actions/SignAction';
import LoggedUserStore from 'stores/LoggedUserStore';
// Images
import PCPLogo from 'assets/img/pcpRectangleLogo.png';
// Facade
import Facade from 'core/Facade';
// Theme
import theme from 'assets/theme/theme';
import styles from 'components/page/LoginPage/LoginPage.style';

class Login extends React.PureComponent {

    state = {
        email: '',
        password: '',
        showPassword: false,
        isLogged: LoggedUserStore.isLogged(),
        isLoading: false
    };

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    componentDidMount() {
        LoggedUserStore.addChangeListener(this.onLoggedUserStoreChange);
        this.mounted = true;
    }

    componentWillUnmount() {
        LoggedUserStore.removeChangeListener(this.onLoggedUserStoreChange);
        this.mounted = false;
    }

    onLoggedUserStoreChange = () => {
        if (!this.mounted) {
            return false;
        }

        this.setState({
            isLogged: LoggedUserStore.isLogged(),
            isLoading: LoggedUserStore.isLoading
        });
    };

    signIn = () => {
        SignAction.signIn(this.state.email, this.state.password)
            .then(() => true,
                () => {
                    if (!this.mounted) {
                        return false;
                    }
                    this.setState({ error: true });
                });
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleKeyPress = (event) => {
        if (event.key === 'Enter')
            this.signIn();
    };

    renderForm() {
        const { classes } = this.props;

        if (this.state.isLogged) {
            return (
                <Redirect to='/dashboard' />
            );
        }

        return (
            <div className={classes.loginBackground}>
                <div className={classes.loginDiv}>
                    <div className={classes.loginContainer}>
                        <div className={classes.loginForm}>
                            <div className={classes.loginTitleDiv}>
                                <Typography className={classes.loginTitle} variant='h3' gutterBottom>
                                    Back<span className={classes.office}>Office</span>
                                    <Typography noWrap className={classes.loginSubtitle}>
                                        PriceComparator
                                    </Typography>
                                </Typography>
                            </div>
                            <div className={classes.loginInputDiv}>
                                <Typography className={classes.inputTitle} variant='h4' gutterBottom>
                                    Username
                                </Typography>
                                <TextField
                                    label='Username'
                                    value={this.state.email}
                                    type='email'
                                    variant='standard'
                                    autoComplete='email'
                                    onChange={this.handleChange('email')}
                                    onKeyPress={this.handleKeyPress}
                                />
                            </div>
                            <div className={classes.loginInputDiv}>
                                <Typography className={classes.inputTitle} variant='h4' gutterBottom>
                                Password
                                </Typography>
                                <TextField
                                    label='Password'
                                    value={this.state.password}
                                    type='password'
                                    variant='standard'
                                    autoComplete='password'
                                    onChange={this.handleChange('password')}
                                    onKeyPress={this.handleKeyPress}
                                />
                            </div>
                            <div className={classes.connectionButtonDiv}>
                                <Button
                                    color='primary'
                                    className={classes.connectionButton}
                                    onClick={() => this.signIn()}>
                                    {translate.i18n('LOGIN_BUTTON')}
                                </Button>
                            </div>
                            {Facade.getEnv() === 'production' ?
                                null
                                :
                                <div style={{ marginTop: '15px', fontSize: '15px', textAlign: 'center', fontWeight: 600, color: theme.palette.primary.main }}>
                                    Vous êtes sur le backoffice de <span style={{ color: '#FF3D3D' }}>{Facade.getEnv().toUpperCase()}</span>
                                </div>
                            }
                        </div>
                        <div className={classes.footerLogoDiv}>
                            <img className={classes.footerLogo} alt='PCPLogo' src={PCPLogo}/>
                            {this.state.isLoading === true ? <LinearProgress /> : ''}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.renderForm()}
            </div>
        );
    }
}

export default withStyles(styles)(Login);
